export default "__VITE_ASSET__CPHmsw4L__"